import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import '../styles/RelatedPortfolioItems.css';

// Portfolio Cover Images
import HondaCover from '../images/portfolio/covers/honda-cover.jpg';
import FancyFeastCover from '../images/portfolio/covers/fancy-feast-cover.jpg';
import WabtecCover from '../images/portfolio/covers/wabtec-cover.png';
import HDpianoCover from '../images/portfolio/covers/hdpiano-cover.png';
import WalmartCover from '../images/portfolio/covers/walmart-cover.png';
import LittlePassportsCover from '../images/portfolio/covers/little-passports-cover.png';

const relatedPortfolioItems = [
    { id: 1, title: 'Honda', image: HondaCover },
    { id: 2, title: 'My Fancy Feast', image: FancyFeastCover },
    { id: 3, title: 'Wabtec', image: WabtecCover },
    { id: 4, title: 'HDpiano', image: HDpianoCover },
    { id: 5, title: 'Walmart', image: WalmartCover },
    { id: 6, title: 'Little Passports', image: LittlePassportsCover },
];

const RelatedPortfolioCarousel = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const currentProjectId = parseInt(id, 10);
  
    const handleNavigation = (projectId) => {
        navigate(`/portfolio/${projectId}`);
    };
  
    const relatedProjects = relatedPortfolioItems.filter((item) => item.id !== currentProjectId);

  return (
    <section className="new-portfolio-carousel-section pb-5">
      <h5 className="text-center my-5">Explore More Projects</h5>
      <div className="new-portfolio-carousel d-flex overflow-hidden justify-content-center">
        {relatedProjects.map((item) => (
          <div
            key={item.id}
            className="new-portfolio-item flex-shrink-0"
            onClick={() => handleNavigation(item.id)}
            style={{ cursor: 'pointer' }}
          >
            <img
              src={item.image}
              alt={item.title}
              className="img-fluid rounded"
            />
            <p className="text-center mt-2">{item.title}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default RelatedPortfolioCarousel;

